import produce from 'immer';
import {
  RANK_SYSTEM_LIST_REQUEST,
  RANK_SYSTEM_UPDATE_REQUEST,
} from '../../constants/app/inAppRankSystemConstants';

const initialState = {

};

const inAppRankSystemReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case RANK_SYSTEM_LIST_REQUEST:
      break;
    case RANK_SYSTEM_UPDATE_REQUEST:
      break;
    default:
      break;
  }
});

export default inAppRankSystemReducer;
